// Styles for Footer go here.
import styled from 'styled-components';
import { toRem, theme } from '../../styles';

export const StyledFooter = styled.div`
  .inner-container {
    @media ${theme.mediaQuery.mobileTablet} {
      padding: 28px 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    @media ${theme.mediaQuery.largeDesktop} {
      padding-left: 100px;
    }
  }
  .footer-link {
    font-size: ${toRem(16)};
    font-weight: 400;
    line-height: 25px;
    margin: 0px 0px 0px 0px;
    @media ${theme.mediaQuery.mobileTablet} {
      font-size: ${toRem(10)};
      font-weight: 400;
      display: block !important;
    }
  }
  .footer-link-wrapper {
    @media ${theme.mediaQuery.mobileTablet} {
      display: flex;
      align-items: center;
    }
  }
  .icon-arrow-right {
    // padding-bottom: 7px;
  }
  .m-nav-link {
    padding: 0px;
    border: 0px;
    color: var(--t-link-text-color);
    &:hover {
      cursor: pointer;
      border-bottom: 0px;
      font-weight: 400;
      text-decoration: underline;
      color: var(--t-link-text-color);
    }
  }
  .copyright {
    @media ${theme.mediaQuery.mobileTablet} {
      font-size: ${toRem(10)};
      font-weight: 400;
      line-height: 16px;
    }
    font-size: ${toRem(12)};
    font-weight: 400;
    line-height: 16px;
    a {
      font-weight: 400;
      text-decoration: underline;
    }
  }
  .footer-bottom-link-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    @media ${theme.mediaQuery.mobileTablet} {
      justify-content: center;
    }
  }
  .hidden {
    display: none;
  }
  .accordion-item {
    background: transparent;
  }
  .icon-arrow-right {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
    @media ${theme.mediaQuery.allMobiles} {
      margin-right: 0rem;
      margin-left: 0rem;
    }
    &:before {
      position: relative;
      top: 0px;
      @media ${theme.mediaQuery.allMobiles} {
        top: 1px;
      }
    }
  }

  .accordion-item {
    border: none !important;
  }
  #teconsent {
    .ot-sdk-show-settings {
      display: inline !important;
      color: var(--t-link-text-color) !important;
      &:hover {
        cursor: pointer;
        border-bottom: 0px;
        font-weight: 400;
        text-decoration: underline;
        color: var(--t-link-text-color) !important;
      }
    }
    .icon-arrow-right {
      display: none !important;
    }
    a {
      font-size: ${toRem(16)} !important;
      font-weight: 400 !important;
      line-height: 25px !important;
      margin: 0px 0px 0px 0px;
      @media ${theme.mediaQuery.allMobiles} {
        font-size: ${toRem(10)} !important;
        font-weight: 400 !important;
        line-height: 16px !important;
        display: inline !important;
        position: relative;
        top: -3px;
      }
      @media ${theme.mediaQuery.allTablets} {
        font-size: ${toRem(10)} !important;
        font-weight: 400 !important;
        line-height: 16px !important;
        display: inline !important;
        position: relative;
        top: -3px;
      }
      @media (min-width: 991px) and (max-width: 1024px) {
        font-size: 1rem !important;
        font-weight: 400 !important;
        line-height: 16px !important;
        display: inline !important;
        position: relative;
      }
    }
  }
`;

export const StyledP = styled.div`
  @media ${theme.mediaQuery.mobileTablet} {
    display: block !important;
    text-align: center;
    font-size: ${toRem(12)};
    font-weight: 700;
    line-height: 16px;
    align-items: center;
    justify-content: center;
    span {
      font-weight: 400;
      font-size: ${toRem(10)};
    }
  }
  font-size: ${toRem(16)};
  font-weight: 700;
  line-height: 20px;
  span {
    font-weight: 400;
  }
`;

export const StyleWrapper = styled.div`
  .footer-container {
    .survey-wrapper__background {
      padding: 0 !important;
    }
    .survey-wrapper__children {
      max-width: 100% !important;
    }
  }
`;
